export const PDP_ESTIMATE_SIMILAR_SOLD_TEST_NAME = 'PDP_1stDibsEstimateSimilarSold_Oct2025';
export const PDP_SIMILAR_SOLD_ITEMS_MODULE_TEST_NAME = 'PDP_SimilarSoldPill_Feb2026';
export const PDP_SPONSORED_MORE_SIMILAR_ITEMS_GRID = 'PDP_Sponsored_MoreSimilarItems_grid';
export const PDP_SPONSORED_INFINITE_GRID_MW = 'PDP_Sponsored_infinitegrid_MW';
export const PDP_INFINITE_SCROLL_SUB_MODULE = 'PDP_InfiniteScrollSubModule_Aug2026';
export const PDP_SELLER_MODULE_TEST_NAME = 'PDP_SellerModuleTest1_July2026';
export const SOLD_PDP_SPONSORED_YMAL_GRID = 'SoldPDP_Sponsored_YMAL_grid';
export const PDP_ITEM_MODULE_TEST_NAME = 'PDP_ItemModuleTest1_Aug2026';
